import { useEffect, useState } from "react";

import BasicDropdown from "../../../ui library/components/dropdowns/BasicDropdown";
import { tableSelectProps } from "../utils/styles";

const ALLOWED_STATUSES = ["Pending", "Declined"];

export default function Status({ initValue, repository, onChange, isTableView = false }) {
  const [data, setData] = useState([]);

  const parseData = (items) =>
    items.map((item) => ({
      id: item.key,
      key: item.key,
      label: item.label,
      disabled: !ALLOWED_STATUSES.includes(item.label),
    }));

  useEffect(() => {
    const fetchData = async () => {
      const response = await repository.query({
        content_type: "providerreferral",
        field_name: "status",
      });
      const mapped = parseData(response);
      setData(mapped);
    };

    fetchData().catch((error) => console.error(error));
  }, [repository]);
  const canEdit = initValue && ALLOWED_STATUSES.includes(initValue?.label || initValue);

  return (
    <BasicDropdown
      initValue={initValue}
      label={isTableView ? "" : "Status"}
      selectProps={isTableView ? tableSelectProps : {}}
      data={data}
      onValueChange={(e, value) => {
        onChange("status", value);
      }}
      addNoSelectionOption={false}
      disabled={!canEdit}
    />
  );
}
